import {ArtfactKind} from '@mrp-brasil/nick-data-commons';
import {Hook, HookClass, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import {Observable, of} from 'rxjs';

@HookClass('color.hook')
export class ColorHook {

    @Hook('d6c20898-06e1-42af-aa76-1de98e3c9a06')
    public contrastColor(input: NickProcessArtfact): Observable<NickProcessArtfact> {
        const colourIsLight = (r: any, g: any, b: any) => {

            // Counting the perceptive luminance
            // human eye favors green color...
            var a = 1 - (0.299 * r + 0.587 * g + 0.114 * b) / 255;
            return (a < 0.5);
        };

        const hexToRgb = (hex: any) => {
            // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
            const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
            hex = hex.replace(shorthandRegex, (m: any, r: any, g: any, b: any) => {
                return r + r + g + g + b + b;
            });

            const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result ? {
                r: parseInt(result[1], 16),
                g: parseInt(result[2], 16),
                b: parseInt(result[3], 16)
            } : null;
        };


        const colorRGB = hexToRgb(input.object.data);

        const outputArtifact = new NickProcessArtfact();
        outputArtifact.kind = ArtfactKind.ANY;
        outputArtifact.object = colourIsLight(colorRGB.r, colorRGB.g, colorRGB.b) ? 'black' : 'white';

        return of(outputArtifact);
    }

    @Hook('cdaf37c7-220b-43f5-9c18-88f67db1b23b')
    public darkLightColor(input: NickProcessArtfact): Observable<NickProcessArtfact> {
        let color = input.object.data.color;
        const amount = input.object.data.value;
        var usePound = false;
        if (color[0] == '#') {
            color = color.slice(1);
            usePound = true;
        }

        var num = parseInt(color, 16);

        var r = (num >> 16) + amount;

        if (r > 255) r = 255;
        else if (r < 0) r = 0;

        var b = ((num >> 8) & 0x00FF) + amount;

        if (b > 255) b = 255;
        else if (b < 0) b = 0;

        var g = (num & 0x0000FF) + amount;

        if (g > 255) g = 255;
        else if (g < 0) g = 0;


        const outputArtifact = new NickProcessArtfact();
        outputArtifact.kind = ArtfactKind.ANY;
        outputArtifact.object = (usePound ? '#' : '') + (g | (b << 8) | (r << 16)).toString(16);

        return of(outputArtifact);
    }

    @Hook('1f1aed97-ffc0-434c-9aed-104673c041a3')
    public randomColor(input: NickProcessArtfact): Observable<NickProcessArtfact> {

        let red = Math.random() * 256 >> 0;
        let green = Math.random() * 256 >> 0;
        let blue = Math.random() * 256 >> 0;

        // mix the color
        if (input.object.config) {
            red = (red + input.object.config.red) / 2 >> 0;
            green = (green + input.object.config.green) / 2 >> 0;
            blue = (blue + input.object.config.blue) / 2 >> 0;
        }
        let rr = red.toString(16);
        if (rr.length === 1) {
            rr = '0' + rr[0];
        }
        let gg = green.toString(16);
        if (gg.length === 1) {
            gg = '0' + gg[0];
        }
        let bb = blue.toString(16);
        if (bb.length === 1) {
            bb = '0' + bb[0];
        }

        const outputArtifact = new NickProcessArtfact();
        outputArtifact.kind = ArtfactKind.ANY;
        outputArtifact.object = `#${rr}${gg}${bb}`;
        return of(outputArtifact);
    }

    @Hook('af43e66b-c581-439a-ac49-b52f32a728be')
    public randomPastelColor(input: NickProcessArtfact): Observable<NickProcessArtfact> {
        const outputArtifact = new NickProcessArtfact();
        outputArtifact.kind = ArtfactKind.ANY;

        outputArtifact.object = 'hsl(' + 360 * Math.random() + ',' +
            (25 + 70 * Math.random()) + '%,' +
            (85 + 10 * Math.random()) + '%)';

        return of(outputArtifact);
    }
}
